import {
  GraduationCap, Layers, UserCheck, IndianRupee, Zap, Lock, BellRing, HeartHandshake,
  Building2, Receipt, FileText, Landmark, Users, BadgeCheck, Copyright, Calculator,
  User, Sprout, Scale, Calendar, RefreshCw, AlertTriangle, Globe, Gavel, Percent,
  ClipboardList, Send, Search, Banknote, Plane, FileSearch, FileCheck, MessageSquare,
  RotateCcw, XCircle, TrendingUp, FileWarning, Scissors,
} from "lucide-react";

const MAP = {
  GraduationCap, Layers, UserCheck, IndianRupee, Zap, Lock, BellRing, HeartHandshake,
  Building2, Receipt, FileText, Landmark, Users, BadgeCheck, Copyright, Calculator,
  User, Sprout, Scale, Calendar, RefreshCw, AlertTriangle, Globe, Gavel, Percent,
  ClipboardList, Send, Search, Banknote, Plane, FileSearch, FileCheck, MessageSquare,
  RotateCcw, XCircle, TrendingUp, FileWarning, Scissors,
};

export const Icon = ({ name, className }) => {
  const Cmp = MAP[name] || Layers;
  return <Cmp className={className} />;
};
